export default class Language {
  name;
  proficiency;
  constructor(data) {
    this.name = data?.name;
    this.proficiency = data?.proficiency;
  }
}
